<div class="container" *ngFor="let prop of propertiesTracker; let i = index">
  <div class="container__left" *ngIf="propertiesTracker.length > 1">
    {{ i + 1 }}
  </div>
  <div class="container__center">
    <app-custom-address
      (onToggleLoading)="noop()"
      (onNavigateByUrl)="noop()"
      (onValueChanged)="onPropertyAddressFieldUpdate($event, i)"
      [setValues]="properties.length > 1 ? properties[i] : setValues"
      [readonly]="readonly"
    ></app-custom-address>
  </div>
  <div class="container__right">
    <mat-icon class="cursor-pointer" *ngIf="i !== 0" matTooltip="Remove" matTooltipPosition="left" (click)="delProp(i)"
      >remove_circle</mat-icon
    >
    <mat-icon
      class="cursor-pointer"
      *ngIf="(i === 0 && propertiesTracker.length === 1) || (i !== 0 && i === propertiesTracker.length - 1)"
      matTooltip="Add"
      matTooltipPosition="left"
      (click)="addProp()"
      >add_circle</mat-icon
    >
  </div>
</div>
